import { useEffect } from 'react';
import { useAuthStore } from '../stores/useAuthStore';

const AUTH_CHECK_TIMEOUT_MS = 30000; // 30 seconds

type UseAuthTimeoutOptions = {
  /** Whether to enable the timeout. Defaults to true. */
  enabled?: boolean;
};

/**
 * Hook that implements a safety timeout for auth checks.
 * Forces auth check completion if it takes too long to prevent infinite loading states.
 *
 * @param options - Optional configuration
 */
export function useAuthTimeout(options: UseAuthTimeoutOptions = {}) {
  const { enabled = true } = options;
  const { hasCheckedAuth, setIsAuthenticated } = useAuthStore();

  useEffect(() => {
    if (enabled && !hasCheckedAuth) {
      const timeoutId = setTimeout(() => {
        console.error(
          'Auth check timeout - forcing completion. This may indicate a network issue.',
        );
        // Force auth check to complete by setting authenticated to false
        // This will trigger the auth modal to show
        setIsAuthenticated(false);
      }, AUTH_CHECK_TIMEOUT_MS);

      return () => clearTimeout(timeoutId);
    }
  }, [enabled, hasCheckedAuth, setIsAuthenticated]);
}
